import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
    getUserDeviceDetails,
    userDeviceDetailsReset
} from '@hero/redux-data/backoffice/userDeviceDetails/actionCreators';
import { userDetailsSelector } from '@hero/redux-data/backoffice/userDeviceDetails/selectors';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import { formatDateTime } from '@hero/hero-utils/date';

const UserHeader: React.FC = () => {
    const dispatch = useDispatch();
    const { user_id } = useParams();
    const user = useSelector(userDetailsSelector, shallowEqual);

    React.useEffect(() => {
        user_id && dispatch(getUserDeviceDetails({ user_id: +user_id }));
    }, [dispatch, user_id]);

    const userData = React.useMemo(() => {
        const userName =
            user?.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : '-';
        return {
            userName,
            email: user?.email || '-'
        };
    }, [user]);

    const loginDetails = React.useMemo(() => {
        const lastSuccessfulLogin = user?.last_successful_login
            ? formatDateTime(user.last_successful_login)
            : 'N/A';
        const lastLoginAttempt = user?.last_login_attempt
            ? formatDateTime(user.last_login_attempt)
            : 'N/A';
        return {
            lastLoginAttempt: `Last Login Attempt: ${lastLoginAttempt}`,
            lastSuccessfulLogin: `Last Successful Login: ${lastSuccessfulLogin}`
        };
    }, [user]);

    React.useEffect(() => {
        return () => {
            dispatch(userDeviceDetailsReset());
        };
    }, [dispatch]);

    return (
        <>
            <H role="h4" noDefaultMargin>
                {userData.userName}
            </H>
            <P noDefaultMargin>{userData.email}</P>
            <P size="small" styles={{ fontStyle: 'italic' }} noDefaultMargin>
                {loginDetails.lastLoginAttempt}
            </P>
            <P size="small" styles={{ fontStyle: 'italic' }} noDefaultMargin>
                {loginDetails.lastSuccessfulLogin}
            </P>
        </>
    );
};

export default UserHeader;
